import React, { useState, useEffect } from 'react';
import { Badge, Card, Col, Pagination, Row, Table, Form, Spinner, Button } from '@themesberg/react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faFilePdf, faTrash } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from "react-i18next";
import StatusSelector from '../../StatusSelector';
const ChangeStatusCell = ({ claim, handleStatusChange }) => {
      const { t } = useTranslation();
    return (
        <td>
            <StatusSelector
                defaultStatus={claim.paymentStatus || "Paid"}
                onChange={(status) => handleStatusChange(claim._id, status)}
            />
        </td>
    );
};

export default ChangeStatusCell;
